export default __webpack_public_path__ + "static/media/testResults.8d9e3d88.svg";